import { useRef } from 'react';
import useMeasure from 'use-measure';

export default function useMeasureContentMain() {
  const containerRef = useRef<HTMLDivElement | null>(
    document.querySelector('.content-main-flex')
  );
  const container = useMeasure(containerRef);

  return container;
}
